module.exports = __webpack_public_path__ + "img/homemid3.3827024a.png";